import { z } from 'zod';

export const GetProposalGoodsServiceRequestSchema = z
  .object({
    campaignProposalId: z.number(),
    page: z.number().min(1),
    size: z.number().min(1).max(100),
  })
  .describe('GetProposalGoodsServiceRequestSchema');

export type GetProposalGoodsServiceRequest = z.infer<typeof GetProposalGoodsServiceRequestSchema>;

const ProposalGoodsItemSchema = z
  .object({
    goodsImageUrl: z.string(),
    linkUrl: z.string(),
    goodsNo: z.number(),
    goodsName: z.string(),
    price: z.number(),
    discountedPrice: z.number(),
  })
  .describe('ProposalGoodsItemSchema');

export type ProposalGoodsItem = z.infer<typeof ProposalGoodsItemSchema>;

export const GetProposalGoodsServiceResponseSchema = z.object({
  list: z.array(ProposalGoodsItemSchema),
  total: z.number(),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.number().optional(),
  }),
});

export type GetProposalGoodsServiceResponse = z.infer<typeof GetProposalGoodsServiceResponseSchema>;
